import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { DynamicConfigService } from './dynamic-config.service';

@Injectable({ providedIn: 'root' })
export class MixpanelService {
  private isActive: boolean = false;

  constructor(private dynamicConfig: DynamicConfigService) {}

  init() {
    // We'll get our Mixpanel token from the dynamic config
    this.dynamicConfig.get('mixpanel_token').subscribe((token) => {
      // Only init Mixpanel if we actually have a token for this environment
      if (token) {
        mixpanel.init(token, {
          loaded: () => {
            // Once Mixpanel is initialized successfully, we set isActive
            // so we know we're allowed to track events later on
            this.isActive = true;
          }
        });
      }
    });
  }

  track(
    event: string,
    properties: { [key: string]: any } = {},
    options: { [key: string]: any } = {},
    callback: () => {} = null
  ) {
    // Only run trackers if Mixpanel has been initialized succesfully
    if (this.isActive) {
      mixpanel.track(event, properties, options, callback);
    }
  }

  identify(id: string) {
    if (this.isActive) {
      mixpanel.identify(id);
    }
  }

  peopleSetOnce(data: any) {
    if (this.isActive) {
      mixpanel.people.set_once(data);
    }
  }

  reset() {
    if (this.isActive) {
      mixpanel.reset();
    }
  }
}
